import React from "react";

export const UiVerticalButtonGroup = (props) => {
  return (
    <>
      <div
        className={props.className ? props.className : "df-vertical-btn-group"}
      >
        {props.children}
      </div>
    </>
  );
};
